<script setup lang="ts">
// Production addition (not in the reference): actionable local-storage failure notice with an export of
// unsynced work. Visual language follows the reference flash toast.
import { storageProblem } from '@/app/offlineWorkspace';
import { t } from '@/app/i18n';
import { downloadText } from '@/app/download';

async function exportWork(): Promise<void> {
  const p = storageProblem.value; if (!p) return;
  downloadText(`taskpanes-unsynced-${new Date().toISOString().slice(0, 10)}.json`, await p.exportUnsynced());
}
</script>

<template>
  <div v-if="storageProblem" role="alert" data-storage-problem
    :style="s('position:absolute; left:50%; top:16px; transform:translateX(-50%); z-index:160; width:max-content; max-width:calc(100% - 32px); box-sizing:border-box; padding:10px 10px 10px 16px; border-radius:calc(12px * var(--tp-round, 1)); background:var(--ne7e7ea, #e7e7ea); color:var(--n1e1f22, #1e1f22); font-size:14px; box-shadow:0 12px 32px rgba(0,0,0,0.35); display:flex; align-items:center; gap:10px; animation:tpToast 200ms ease-out;')">
    <span :style="s('flex:1; min-width:0;')">{{ t(storageProblem.message) }}</span>
    <button @click="exportWork" :style="s('height:30px; padding:0 14px; border:none; border-radius:calc(8px * var(--tp-round, 1)); background:#e2837a; color:#16171a; font-family:inherit; font-size:13px; font-weight:700; cursor:pointer;')">{{ t('Export unsynced work') }}</button>
    <button :title="t('Dismiss')" @click="storageProblem = null" :style="s('width:28px; height:28px; border:none; background:transparent; color:var(--n1e1f22, #1e1f22); opacity:0.6; font-size:16px; cursor:pointer;')">×</button>
  </div>
</template>
